import { render, staticRenderFns } from "./layout-fullscreen.vue?vue&type=template&id=2e6d26ec"
import script from "./layout-fullscreen.vue?vue&type=script&lang=js"
export * from "./layout-fullscreen.vue?vue&type=script&lang=js"
import style0 from "./layout-fullscreen.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports